import { render, staticRenderFns } from "./goods6.vue?vue&type=template&id=270a7889&scoped=true"
import script from "./goods6.vue?vue&type=script&lang=js"
export * from "./goods6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a7889",
  null
  
)

export default component.exports